//
//
//
//
//
//
//
//
//
//

import PageMixin from '~/mixins/page'
import IntercomMixin from '~/mixins/intercom'

export default {
  mixins: [
    PageMixin,
    IntercomMixin
  ],
  layout: 'empty',
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t('quiz.seo.title'),
        description: this.$t('quiz.seo.description'),
        url: 'https://get-base.com/quiz'
      })
    }
  },
  mounted () {
    this.shutdownIntercomWidget()
    this.trackFBPixelEvent({ event: 'QuizStarted' })
  }
}
